// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3uebc","amount":"Amount_amount__3Dzcc","tip":"Amount_tip__KkPfO","tipHeader":"Amount_tipHeader__1N_Dx","tipsWrap":"Amount_tipsWrap__2LDkl"};